import { Alert, Modal, Button, Upload, message, Card, Row, Col } from 'antd';
import { AiOutlineCloudDownload } from 'react-icons/ai';
import XLSX from 'xlsx';
import { InboxOutlined } from '@ant-design/icons';
import { useState } from 'react';
import ErrorModalTable from '../../upload-modal/error-modal-table';
import CreateResultModal from './create-result-modal';

const { Dragger } = Upload;

const UploadModal = ({ onClose, onUploadedData, setStep }) => {
  const [errorModal, setErrorModal] = useState(false);
  const [uploadedData, setUploadedData] = useState(false);
  const [createResultModal, setCreateResultModal] = useState(false);

  const handleParseData = (data) => {
    if (!data || data.length < 1) {
      message.error('Excelde yüklenebilecek bir kişi bulunamadı.');
      return false;
    }
    const arr = [];
    const errorObj = {};
    data.forEach((item, index) => {
      errorObj[index] = [];

      if (!item['Ad']) {
        errorObj[index].push('Kişi Adı eksik');
      }
      if (!item['Soyad']) {
        errorObj[index].push('Kişi Soyadı eksik');
      }
      if (!item['Telefon Numarası']) {
        errorObj[index].push('Telefon Numarası eksik');
      }
      if (!item['İl']) {
        errorObj[index].push('İl eksik');
      }
      if (!item['İlçe']) {
        errorObj[index].push('İlçe eksik');
      }
      if (!item['Açık Adres']) {
        errorObj[index].push('Açık Adres eksik');
      }

      if (errorObj[index].length === 0) {
        let obj = {
          firstName: item['Ad'],
          lastName: item['Soyad'],
          phone: item['Telefon Numarası'].toString(),
          city: { name: item['İl'] },
          town: { name: item['İlçe'] },
          district: { name: item['Mahalle'] },
          addressLine: item['Açık Adres'],
        };

        arr.push(obj);
      }
    });

    if (Object.values(errorObj).flat().length > 0) {
      return setErrorModal(errorObj);
    }

    setUploadedData(arr);
  };

  const handleSave = () => {
    const arr = [];
    uploadedData.forEach((item) => {
      arr.push({
        ...item,
      });
    });
    setCreateResultModal(arr);
  };

  const props = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    action: false,
    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    beforeUpload: () => {
      return false;
    },
    onChange(info) {
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = () => {
            const workbook = XLSX.read(reader.result, { type: 'binary' });
            const firstSheet = workbook.SheetNames[0];
            const excelRows = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[firstSheet]
            );
            handleParseData(excelRows);
          };
          reader.readAsBinaryString(info.file);
        }
      }
      return false;
    },
  };

  return (
    <>
      {errorModal && (
        <ErrorModalTable
          result={errorModal}
          onClose={() => setErrorModal(false)}
        />
      )}
      {createResultModal && (
        <CreateResultModal
          data={createResultModal}
          onClose={() => {
            onClose();
            setCreateResultModal(false);
          }}
          setStep={setStep}
        />
      )}
      <Modal
        visible
        title="Excel ile Kişi Yükle"
        onCancel={onClose}
        width={1350}
        footer={false}
      >
        {uploadedData.length > 0 ? (
          <>
            <Alert
              type="warning"
              showIcon
              message={`${uploadedData.length} adet kişiyi yüklemek üzeresiniz. Aşağıdaki seçeneklerden birini seçerek yükleme yapabilirsiniz.`}
            />

            <div style={{ marginTop: 24 }}>
              <Row gutter={24}>
                <Col span={12}>
                  <Card title="Doğrudan Yükle" size="small">
                    <p>
                      Kişiler forma eklenmeden doğrudan kaydedilir. Çoklu kişi
                      yüklemek için tavsiye edilir.
                    </p>

                    <Button block type="primary" onClick={() => handleSave()}>
                      Yükle
                    </Button>
                  </Card>
                </Col>
              </Row>
            </div>
          </>
        ) : (
          <>
            <Alert
              type="info"
              showIcon
              message="Excel ile kişi yükleyebilmek için örnek excel şablonunu doldurmanız gerekmektedir."
              action={
                <Button
                  size="small"
                  type="primary"
                  icon={<AiOutlineCloudDownload />}
                  onClick={() => window.open('/files/Toplu Kişi Excel.xlsx')}
                >
                  Örnek Şablonu İndir
                </Button>
              }
            />
            <div style={{ marginTop: 24 }}>
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Dosya yüklemek için buraya tıklayın veya dosyanızı sürükleyip
                  bu alana bırakın.
                </p>
              </Dragger>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default UploadModal;
